var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"card",class:[_vm.$org('slug'), {'is-centered': _vm.centered, 'has-org-bg': _vm.organization}]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }